import { styled } from 'goober';

export const DatasetListTable = styled('table')`
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
`;

export const DatasetListTh = styled('th')`
    text-align: left;
    padding: 8px 12px;
    font-weight: 600;
    color: ${(props) => props.theme.colors.neutral.w600};
    border-bottom: 1px solid ${(props) => props.theme.colors.neutral.w200};
    font-size: 12px;
    cursor: pointer;
    user-select: none;
    &:hover {
        color: ${(props) => props.theme.colors.neutral.w800};
    }
`;

export const DatasetListTd = styled('td')`
    padding: 8px 12px;
    border-bottom: 1px solid ${(props) => props.theme.colors.neutral.w50};
`;

export const DatasetRow = styled('tr')`
    cursor: pointer;
    &:hover {
        background: ${(props) => props.theme.colors.neutral.w50};
    }
`;

export const FormatBadge = styled('span')`
    display: inline-block;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 500;
    background: ${(props) => props.theme.colors.neutral.w100};
    color: ${(props) => props.theme.colors.neutral.w600};
    font-family: 'SF Mono', 'Fira Code', monospace;
`;

export const DetailHeader = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 12px;
    border-bottom: 1px solid ${(props) => props.theme.colors.neutral.w200};
`;

export const BackButton = styled('button')`
    background: none;
    border: none;
    font-size: 13px;
    color: ${(props) => props.theme.colors.primary.w500};
    cursor: pointer;
    padding: 0;
    &:hover {
        text-decoration: underline;
    }
`;

export const SectionLabel = styled('div')`
    font-size: 12px;
    font-weight: 600;
    color: ${(props) => props.theme.colors.neutral.w600};
`;

export const EmptyState = styled('div')`
    text-align: center;
    padding: 40px 20px;
    color: ${(props) => props.theme.colors.neutral.w500};
    font-size: 13px;
`;

export const ActionButton = styled('button')<{ $danger?: boolean }>`
    background: none;
    border: 1px solid ${(props) => (props.$danger ? props.theme.colors.error.w300 : props.theme.colors.neutral.w200)};
    border-radius: 4px;
    padding: 4px 10px;
    font-size: 12px;
    color: ${(props) => (props.$danger ? props.theme.colors.error.w500 : props.theme.colors.neutral.w600)};
    cursor: pointer;
    &:hover {
        background: ${(props) => (props.$danger ? props.theme.colors.error.w50 : props.theme.colors.neutral.w50)};
    }
`;

export const VersionBadge = styled('span')<{ $current?: boolean }>`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 3px;
    font-size: 11px;
    font-weight: 500;
    background: ${(props) => (props.$current ? props.theme.colors.primary.w100 : props.theme.colors.neutral.w100)};
    color: ${(props) => (props.$current ? props.theme.colors.primary.w700 : props.theme.colors.neutral.w600)};
    text-transform: ${(props) => (props.$current ? 'none' : 'uppercase')};
    letter-spacing: ${(props) => (props.$current ? 'normal' : '0.3px')};
`;
